var React = require('react');

function Eye (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 -5.625)"},[React.createElement("path",{"d":"M21.455,13S17.432,5.625,10.727,5.625,0,13,0,13s4.023,7.375,10.727,7.375S21.455,13,21.455,13ZM1.573,13A17.612,17.612,0,0,0,3.8,15.74a9.992,9.992,0,0,0,6.929,3.294,10,10,0,0,0,6.93-3.294A17.612,17.612,0,0,0,19.883,13a17.61,17.61,0,0,0-2.226-2.74,10,10,0,0,0-6.93-3.294A10,10,0,0,0,3.8,10.26,17.61,17.61,0,0,0,1.572,13Z","fill":"currentColor","fillRule":"evenodd","key":0}),React.createElement("path",{"d":"M14.818,11.466a3.352,3.352,0,1,0,3.352,3.352,3.352,3.352,0,0,0-3.352-3.352Zm-4.693,3.352a4.693,4.693,0,1,1,4.693,4.693A4.693,4.693,0,0,1,10.125,14.818Z","transform":"translate(-4.091 -1.818)","fill":"currentColor","fillRule":"evenodd","key":1})]));
}

Eye.defaultProps = {"width":"21.455","height":"14.75","viewBox":"0 0 21.455 14.75"};

module.exports = Eye;

Eye.default = Eye;
